import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './Pages/Home.js';
import Resume from './Pages/Resume.js';
import Legal from './Pages/Privacy';
import Evently from './Pages/Evently';
import RettichProductions from './Pages/RettichProductions';
import CovidKiosk from './Pages/CovidKiosk';
import './index.css';
import reportWebVitals from './reportWebVitals';



ReactDOM.render(
  <React.StrictMode>
    <Router onUpdate={() => window.scrollTo(0,0)}>
      <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route exact path="/resume" component={Resume}></Route>
          <Route exact path="/legal" component={Legal}></Route>
          <Route exact path="/evently" component={Evently}></Route>
          <Route exact path="/rettich-productions" component={RettichProductions}></Route>
          <Route exact path="/covid-kiosk" component={CovidKiosk}></Route>
      </Switch>
    </Router>
          
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
